const prefix = 'hc-switch';

/**
 * Collection of class names inside Switch component.
 *
 * These styles basically only mark component in named way in case you want to override styles in parent
 */
export const SwitchClassNames = {
  Root: `${prefix}-root`,
  PillsContainer: `${prefix}-pills-container`,
  InactivePill: `${prefix}-inactive-pill`,
  ActivePill: `${prefix}-active-pill`,
  Label: `${prefix}-label`,
};
